import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import React from "react";
import { RatingOverviewContext } from "../../context/ratingOverviewContext";
import IRatingOverviewSearch from "../../interface/iRatingOverviewSearch";

const SearchStarMax = (): React.JSX.Element => {
  const {
    ratingOverviewSearch,
    setRatingOverviewSearch,
  }: {
    ratingOverviewSearch: IRatingOverviewSearch;
    setRatingOverviewSearch: React.Dispatch<
      React.SetStateAction<IRatingOverviewSearch>
    >;
  } = React.useContext(RatingOverviewContext);

  const handleChange = (e: any): void =>
    setRatingOverviewSearch((prevState: any) => ({
      ...prevState,
      ratingTo: e.target.value,
    }));

  return (
    <FormControl fullWidth>
      <InputLabel id="select-label-min-rating">&#8960; bis</InputLabel>
      <Select
        labelId="select-min-rating"
        id="select-min-rating"
        value={ratingOverviewSearch.ratingTo}
        label="Sterne min"
        onChange={handleChange}
      >
        <MenuItem value={1}>1</MenuItem>
        <MenuItem value={2}>2</MenuItem>
        <MenuItem value={3}>3</MenuItem>
        <MenuItem value={4}>4</MenuItem>
        <MenuItem value={5}>5</MenuItem>
      </Select>
    </FormControl>
  );
};

export default SearchStarMax;
